import { Component, Input, signal, ViewChild, WritableSignal, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MyConfigOrganization } from '../../../../../models/myConfig';
import { OrganizationParkingPricingVM } from '../../../../../models/orderModel';
import { ParkingPricingFormComponent } from '../parking-pricing-form/parking-pricing-form.component';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-parking-pricing-list',
  standalone: false,
  templateUrl: './parking-pricing-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './parking-pricing-list.component.css'
})
export class ParkingPricingListComponent implements AfterViewInit {
  parkingPricingList: WritableSignal<OrganizationParkingPricingVM[]> = signal([]);
  emptyData = new MatTableDataSource([{ empty: "row" }]);
  dataSource = new MatTableDataSource<OrganizationParkingPricingVM>();
  @Input() set parkingPricingListInput(value: OrganizationParkingPricingVM[]) {
    if (value) {
      this.parkingPricingList.set(value);
    }
  }
  loading: boolean;
  @Input() organization: MyConfigOrganization;
  displayedColumnsAdditionalServices: string[] = [
    // "id",
    "code",
    "name",
    // "description",
    "price",
    "vat",
    "totalPrice",
    "active",
    "productTypeName"
  ];
  @Input() productTypes: any[] = [
    { name: { en:"Parking", sv:"Parkering" }, value: 1 },
    { name: { en:"DriveIn", sv:"DriveIn" }, value: 11 },
    { name: { en:"Subscription", sv:"Abonnemang" }, value: 10 }
  ];

  @ViewChild(MatSort) sort: MatSort;

  constructor(
    public dialog: MatDialog,
  ) { }

  getStatusColor(status) {
    switch (status) {
      case "Active":
        return '#28a745';
      case "Expired":
        return "#dc3545";
      default:
        return '#ffc107';
    }
  }

  ngOnInit(): void {
    // if (this.parkingPricingList()) {
    //   this.setTotalPriceForParkingPrice();
    // }
    // this.dataSource.data = this.parkingPricingList();
  }

  ngOnChanges() {
    if (this.parkingPricingList()) {
      this.setTotalPriceAndParkingTypeForParkingPrice();
    }
    this.dataSource.data = this.parkingPricingList();
  }

  // changeParking(value: string) {
  //   console.log('value', value);
  //   this.parkingPricingId = value;
  //   this.getOrganizationParkingPrices();
  // }

  // getOrganizationParkingPrices() {
  //   this.incrementRequests();
  //   this.BackOfficeService
  //     .getOrganizationParkingPrices(this.organization.organizationId, this.parkingPricingId)
  //     .pipe(takeUntil(this.componentDestroyed$))
  //     .subscribe(parkingPrices => {
  //       this.organizationParkingPrices.set(parkingPrices);
  //       // console.log('organizationParkingPrices', this.organizationParkingPrices());
  //       setTimeout(() => {
  //         this.dataSourceDiscountCodes.sort = this.sortCheckIn;
  //       });
  //       this.decrementRequests();
  //     },
  //       () => {
  //         this.decrementRequests();
  //       });
  // }

  //   openBulkUpdateParkingPricingModal() {
  //     if (!this.isLoading) {
  //       // var model: any = parkingPricing ? parkingPricing : null;

  //       const dialogRef = this.dialog.open(ParkingPricingBulkUpdateFormComponent, {
  //         // height: '1010px',
  //         // minHeight: '80vh',
  //         width: '720px',
  //         hasBackdrop: true,
  //         data: {
  //           parkingId: this.parkingPricingId,
  //           parkingPricing: this.organizationParkingPrices(),
  //           organization: this.organization,
  //           // edit: parkingPricing ? true : false,
  //         }
  //       });

  //       dialogRef.afterOpened().subscribe(() => {
  //         const componentInstance = dialogRef.componentInstance as ParkingPricingBulkUpdateFormComponent;
  //         componentInstance.saveChangesEvent.subscribe(() => {
  //           this.getOrganizationParkingPrices();
  //         });
  //       });
  //     }
  //   }


  ngAfterViewInit() {
    this.dataSource.sort = this.sort;

    this.dataSource.sortingDataAccessor = (item, property) => {
      if (property === 'code') {
        const match = item.code && typeof item.code === 'string'
          ? item.code.match(/:(\d+)/)
          : null;
        return match ? parseInt(match[1], 10) : 0;
      }

      switch (property) {
        case 'name':
          return item.name?.toLowerCase() || '';
        case 'description':
          return item.description?.toLowerCase() || '';
        case 'price':
          return item.price || 0;
        case 'vat':
          return item.vat || 0;
        case 'totalPrice':
          return item.totalPrice || 0;
        case 'active':
          return item.active ? 1 : 0;
        default:
          return item[property];
      }
    };

    this.sort.active = 'code';
    this.sort.direction = 'asc';
    this.dataSource.sort = this.sort;
  }

  setTotalPriceAndParkingTypeForParkingPrice() {
    this.parkingPricingList.update(pricings => {
      return pricings.map((pricing) => {
        if (pricing.price && pricing.vat) {
          pricing.totalPrice = pricing.price * (1 + (pricing.vat / 100));
          pricing.productTypeName = this.productTypes.find(type => type.value === pricing.productType)?.name;
        }
        return pricing;
      });
    });
  }

  openEditPricingModal(parkingPricing?: any) {
    if (this.parkingPricingList()?.length > 0) {
      var model: any = parkingPricing ? parkingPricing : null;

      const dialogRef = this.dialog.open(ParkingPricingFormComponent, {
        // height: '1010px',
        // minHeight: '80vh',
        width: '720px',
        hasBackdrop: true,
        data: {
          parkingPricing: model,
          organization: this.organization,
          edit: model ? true : false,
        }
      });

      dialogRef.afterOpened().subscribe(() => {
        const componentInstance = dialogRef.componentInstance as ParkingPricingFormComponent;
        componentInstance.saveChangesEvent.subscribe((parkingPricing) => {
          this.updatePricing(parkingPricing);
        });
      });
    }
  }

  updatePricing(parkingPricing) {
    const currentPricings = this.parkingPricingList();
    const index = currentPricings.findIndex(dc => dc.id === parkingPricing.id);

    if (index > -1) {
      const updatedPricings = [...currentPricings];
      updatedPricings[index] = parkingPricing;
      this.parkingPricingList.set(updatedPricings);
    }
    else {
      this.parkingPricingList.update(pricings => [parkingPricing, ...pricings]);
    }
  }
}
